(() => {
  const selectors = {
    slider: ".shop-merchandise__slider-wrapper",
  };

  var swiper = new Swiper(selectors.slider, {
    spaceBetween: 16,
    slidesPerView: 1.22,
    breakpoints: {
      768: {
        spaceBetween: 16,
        slidesPerView: 2,
      },
      1100: {
        spaceBetween: 16,
        slidesPerView: 3,
      }
    }
  });
})();
